import { Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../theming/appTheme.mjs';
import {
  title1ahgushtajx2d as title,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
} from '../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function FourOhFour$render$lambda($this$title) {
  $this$title.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Not Found';
  var tmp = $this$title.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.fbu(tmp_0);
  return Unit_instance;
}
var FourOhFourClass;
function FourOhFour() {
  if (FourOhFourClass === VOID) {
    class $ {
      ud6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        var tmp = view.ibb(get_centered(view), view.hbb(NothingHereSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        title(view_0, FourOhFour$render$lambda);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
        view_1.bbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = "Sorry, we couldn't find the page you are looking for.";
        var tmp_0 = view_1.tb5_1;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_1 = '\xA0';
        } else {
          tmp_1 = value;
        }
        tmp_0.fbu(tmp_1);
        view_0.fbb(p_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForObject($, 'FourOhFour', VOID, VOID, [Page()]);
    FourOhFourClass = $;
  }
  return FourOhFourClass;
}
var FourOhFour_instance;
function FourOhFour_getInstance() {
  return FourOhFour_instance;
}
//region block: init
FourOhFour_instance = new (FourOhFour())();
//endregion
//region block: exports
export {
  FourOhFour as FourOhFour2zwj647snm4n2,
  FourOhFour_instance as FourOhFour_instance1sei8oq9p2wtd,
};
//endregion

//# sourceMappingURL=FourOhFour.mjs.map
